const blogPagination = (pageCount, currentPage = 1) => [...Array(pageCount)].map((_, page) => `
    <div id="blog-pagination-page-${page + 1}" class="page-number ${page + 1 === currentPage ? 'selected' : ''}">
        ${page + 1}
    </div>
`).join('');

export default blogPagination;